<template>
  <div style="padding-top: 250px;">
    <div style="text-align:center;">
      <h2>Page not found</h2>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>
